import { useState } from 'react';
import axios from 'axios';
import { useAppSelector } from 'src/services/redux/app/Store';
import { ICategoryTree, IAttributeList, IProductAdd, ICategory } from '../interfaces';
import { useQuery } from '@tanstack/react-query';
import { withVendorURL } from 'src/helpers/service';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;

export const useCategoryList = () => {
  const [data, setData] = useState<ICategoryTree[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const { user } = useAppSelector((state) => state.auth);

  const getCategoryList = async () => {
    setLoading(true);
    try {
      const res = await axios.get<ICategoryTree[]>(`${VENDOR_MC_URL}/${user?.vendor.id}/category/tree/list`);
      setData(res.data);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return { getCategoryList, loading, data, error, setError };
};

export const useAttributeList = () => {
  const [data, setData] = useState<IAttributeList | any>({} as IAttributeList);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const { user } = useAppSelector((state) => state.auth);

  const getAttributeList = async (categoryId: number) => {
    setLoading(true);
    try {
      const res: any = await axios.get<IAttributeList>(`${VENDOR_MC_URL}/${user?.vendor.id}/category/${categoryId}/attribute/list`);
      setData(res.data);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };
  return { getAttributeList, loading, data, error, setError, setData };
};

export const useProduct = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const { user } = useAppSelector((state) => state.auth);
  const [done, setDone] = useState<boolean>(false);

  interface IRequest {
    products: IProductAdd[];
  }

  const createProduct = async (body: IRequest) => {
    setLoading(true);
    setDone(false);
    try {
      await axios.post(`${VENDOR_MC_URL}/${user?.vendor.id}/product/pool/add`, body);
      setDone(true);
    } catch (error: any) {
      let errorMessage = "";
      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.response?.data?.violations && error.response.data.violations.length > 0) {
        errorMessage = error.response.data.violations[0].title;
      } else {
        errorMessage = "Bir hata oluştu.";
      }
      setError(errorMessage);
      // switch (error?.response?.data?.errorCode) {
      //   case 'VENDOR_ACCESS_DENIED':
      //     setError('Hata! Onaylanmayan satıcı.');
      //     break;
      //   case 'BRAND_NOTEXIST':
      //     setError('Hata! Marka bulunamadı.');
      //     break;
      //   case 'BRAND_EXCLUSIVE_NOT_AUTHORIZED':
      //     setError('Hata! Münhasır satıcıya yetkiniz bulunmuyor.');
      //     break;
      //   case 'VENDOR_RETURN_ADDRESS_NOT_CORRECT':
      //     setError('Hata! İade adresi doğru değil');
      //     break;
      //   case 'VENDOR_SHIPMENT_ADDRESS_NOT_CORRECT':
      //     setError('Hata! Sevkiyat adresi doğru değil');
      //     break;
      //   case 'ATTRIBUTEVALUE_NOT_DEFINED':
      //     setError('Hata! Ürün özelliği Doğru değil');
      //     break;
      //   case 'CATEGORY_MANDATORY_ATTRIBUTE_MISSED':
      //     setError('Hata! Kategorinin zorunlu ürün özellikleri eksik.');
      //     break;
      //   case 'PRODUCT_IMAGE_MANDATORY_ONCREATE':
      //     setError('Hata! En az bir resim eklenmeli.');
      //     break;
      //   case 'PRODUCT_POOL_ALREADY_EXIST':
      //     setError('Hata! Ürün zaten mevcut, lütfen barkodu kontrol edin.');
      //     break;
      //   default:
      //     setError('Hata! Tekil ürün oluşturulamadı.');
      //     break;
      // }
    } finally {
      setLoading(false);
    }
  };
  return { createProduct, loading, error, setError, done, setDone };
};

export const useProductImage = () => {
  const [resultUrl] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const { user } = useAppSelector((state) => state.auth);

  const uploadFile = async (formData: FormData) => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${VENDOR_MC_URL}/${user?.vendor.id}/image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return data;
    } catch (error: any) {
      setError(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  return {
    uploadFile,
    resultUrl,
    loading,
    error,
    setError,
  };
};

export const useBarcodeProductControl = () => {
  const [data, setData] = useState<any>([]);
  const [notFound, setNotFound] = useState<any>(false);
  const { user } = useAppSelector((state) => state.auth);

  const getBarcodeProductControl = async (search: string, validation: any, index: any, field: string, setValidationProducts: any) => {
    try {
      var res = await axios.get(`${VENDOR_MC_URL}/${user?.vendor?.id}/product/pool/${search}/check`);
      setData(res.data);
      setNotFound(false);
      setValidationProducts(validation);
      return { notFound: false };
    } catch (error) {
      setNotFound(true);
      setValidationProducts(validation);
      return { notFound: true };
    }
  };
  return { getBarcodeProductControl, notFound, setNotFound, data };
};

export const useBarcodeIdefixControl = () => {
  const [data, setData] = useState<any>([]);
  const [notFound, setNotFound] = useState<any>(false);
  const { user } = useAppSelector((state) => state.auth);

  const getBarcodeIdefixControl = async (search: string, validation: any, index: any, field: string, setValidationProducts: any) => {
    try {
      var res = await axios.get(`${VENDOR_MC_URL}/${user?.vendor?.id}/product/pool/check-idefix-catalog-by-barcode/${search}`);
      setData(res.data);
      setNotFound(false);
      setValidationProducts(validation);
      if (!res.data.success) throw new Error('Bulunamadı');
      return { notFound: false, res: res.data };
    } catch (error) {
      setNotFound(true);
      return { notFound: true };
    }
  };

  return { getBarcodeIdefixControl, notFound, setNotFound, data };
};

export const useStockCodeProductControl = () => {
  const [data, setData] = useState<any>([]);
  const [notFound, setNotFound] = useState<any>(false);
  const { user } = useAppSelector((state) => state.auth);

  const getStockCodeProductControl = async (search: string, validation: any, setValidationProducts: any) => {
    try {
      var res = await axios.get(`${VENDOR_MC_URL}/${user?.vendor?.id}/product/pool/vendorStockCode/${search}/check`);
      setData(res.data);
      setNotFound(false);
      setValidationProducts && setValidationProducts(validation);
      return { notFound: false };
    } catch (error) {
      setNotFound(true);
      setValidationProducts && setValidationProducts(validation);
      return { notFound: true };
    }
  };
  return { getStockCodeProductControl, notFound, setNotFound, data };
};

export const useCheckProductPriceControl = () => {
  const [data, setData] = useState<any>();
  const { user } = useAppSelector((state) => state.auth);

  const getCheckProductPriceControl = async (id: string) => {
    try {
      var res = await axios.get(`${VENDOR_MC_URL}/vendor/${user?.vendor?.id}/inventory/check-product-price/${id}`);
      setData(res.data);
    } catch (error: any) {
      setData(error?.response?.data);
    }
  };
  return { getCheckProductPriceControl, data };
};

export const useCheckVariantProductPriceControl = () => {
  const { user } = useAppSelector((state) => state.auth);

  const getCheckVariantProductPriceControl = async (id: number) => {
    try {
      var res = await axios.get(`${VENDOR_MC_URL}/vendor/${user?.vendor?.id}/inventory/check-product-price/${id}`);
      return res.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  };
  return { getCheckVariantProductPriceControl };
};

export const useCategoryInfo = (categoryId?: number) => {

  const fetchInventory = async () => {
    const res = await axios.get<ICategory>(withVendorURL(`/category/${categoryId}/info`));
    return res?.data || {};
  };

  return useQuery(['categoryInfo', categoryId], fetchInventory, {
    enabled: !!categoryId,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });
}